import { render } from "./CustomStyles.vue?vue&type=template&id=f3c8b530&scoped=true"
import script from "./CustomStyles.vue?vue&type=script&lang=js"
export * from "./CustomStyles.vue?vue&type=script&lang=js"

import "./CustomStyles.vue?vue&type=style&index=0&id=f3c8b530&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c8b530"]])

export default __exports__